var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardEach5MinIcon = function SvgNewcsDashboardEach5MinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_each5min_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27 208h14v12H27z",
    "data-name": "\\u77E9\\u5F62 325"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_each5min_icon_svg__a)",
    transform: "translate(-27 -208)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#807997",
    d: "m30.761 218.24.947-.947a4.63 4.63 0 0 0 3.293 1.374 4.67 4.67 0 0 0 3.3-1.365 4.66 4.66 0 0 0 1.366-3.3 4.66 4.66 0 0 0-1.366-3.3 4.66 4.66 0 0 0-3.3-1.366 4.66 4.66 0 0 0-3.3 1.366 4.66 4.66 0 0 0-1.365 3.3h2l-2.693 2.686-.048-.094L27.001 214h2a6 6 0 0 1 6-6 6 6 0 0 1 6 6 6 6 0 0 1-6 6h-.01a5.97 5.97 0 0 1-4.23-1.76m3.193-1.793a1.75 1.75 0 0 1-.6-1.145l1.094-.113a.95.95 0 0 0 .277.589.76.76 0 0 0 .532.216.74.74 0 0 0 .581-.279 1.27 1.27 0 0 0 .238-.841 1.15 1.15 0 0 0-.237-.791.79.79 0 0 0-.615-.264 1.12 1.12 0 0 0-.848.418l-.891-.129.563-2.981h2.9v1.028h-2.07l-.172.973a1.66 1.66 0 0 1 .75-.184 1.65 1.65 0 0 1 1.238.531 1.91 1.91 0 0 1 .508 1.379 2.07 2.07 0 0 1-.41 1.262 1.82 1.82 0 0 1-1.551.758 1.93 1.93 0 0 1-1.287-.427",
    "data-name": 0
  }))));
};
export default SvgNewcsDashboardEach5MinIcon;